var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-d5052718-fc38-4333-b734-afbfcf94f2f0",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-67a089b4-9166-4d45-9306-10ef897887df {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-67a089b4-9166-4d45-9306-10ef897887df",
    d: "M21.81,16l.61-5.55-1.64.72c-1.27-1.26-2.98-1.97-4.78-1.97-3.75,0-6.81,3.05-6.81,6.81s3.05,6.81,6.81,6.81c.22,0,.91,0,1.78-.24.53-.14.85-.69.71-1.23-.14-.53-.7-.85-1.23-.71-.62.17-1.1.17-1.26.17-2.65,0-4.81-2.16-4.81-4.81s2.16-4.81,4.81-4.81c.99,0,1.95.31,2.74.87l-1.44.63,4.5,3.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.bc58fe2e16e8cb86f621a7a1f64bd65f.svg";
export { ForwardRef as ReactComponent };